
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 5.5l-3-3-3 3-3-3-3 3-4-3v23a1 1 0 001 1h18a1 1 0 001-1v-23l-4 3zm-5 16H8v-2h7v2zm0-4H8v-2h7v2zm0-4H8v-2h7v2zm5 8h-3v-2h3v2zm0-4h-3v-2h3v2zm0-4h-3v-2h3v2z","fill":"#565D6D"}})])
          )
        }
      }
    